import { AppState } from '../../../../app/app.global';
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { VerifyByPhoneFirstPage } from '../types/byphone/first/byphonefirst';
import { VerifyByQuestionPage } from '../types/byquestion/byquestion';
@Component({
  selector: 'login-children-page',
  templateUrl: 'list.html'
})
export class RetrieveListPage {

  constructor(public navCtrl: NavController,public global: AppState) {

  }
/*  openItemPage(item){
  	this.navCtrl.push(RetrieveItemPage, { item: item });
  }*/
  goRetrieveTypes(type){
    	if(type == "phone"){
    		this.navCtrl.push(VerifyByPhoneFirstPage, {});
    	}else if(type == "secrity"){
    		this.navCtrl.push(VerifyByQuestionPage, {});
    	}

  }
}



// WEBPACK FOOTER //
// ./src/pages/login/password/items/list.ts